import i01 from './pf_01.png';
import i02 from './pf_02.png';
import i03 from './pf_03.png';
import i04 from './pf_04.png';
import i05 from './pf_05.png';
import i06 from './pf_06.png';
import i07 from './pf_07.png';
import i08 from './pf_08.png';
import i09 from './pf_09.png';
import i10 from './pf_10.png';
import i11 from './pf_11.png';
import i12 from './pf_12.png';
import i13 from './pf_13.png';
import i14 from './pf_14.png';
import i15 from './pf_15.png';
import i16 from './pf_16.png';
import i17 from './pf_17.png';
import i18 from './pf_18.png';
import i19 from './pf_19.png';
import i20 from './pf_20.png';
import i21 from './pf_21.png';
import i22 from './pf_22.png';
import i23 from './pf_23.png';

export let logosMonettaPF = [i01, i02, i03, i04, i05, i06, i07, i08, i09, i10, i11, i12, i13, i14, i15, i16, i17, i18, i19, i20, i21, i22, i23]